import React, { Component } from "react"
import { Table, Icon, message, Row } from "antd"
import "./Index.scss"
import { observer, inject } from "mobx-react"
import MaterialTip from "app/components/normal/MaterialTip/MaterialTip"
import WarningTip from "app/components/normal/WarningTip/WarningTip"
import ShareModal from "app/components/normal/ShareModal"
import RemarkModal from "app/components/normal/RemarkModal"
import { disposeFileSize } from "app/vendor/util"
import { Link } from "react-router-dom"
import cx from "classnames"
import cancelIcon from "app/styles/images/sp/cancel2.svg"
import closeIcon from "app/styles/images/sp/close.svg"
import deleteWarningIcon from "app/styles/images/sp/delete-warning.svg"
import editAbleIcon from "app/styles/images/sp/edit.svg"
import ellipsisDispose from "app/utils/ellipsisDispose"
import copyText from "app/utils/copyText"
import Highlighter from "app/components/normal/HighLighter"
import highlightable from "app/utils/highlightable"
import FlexableFileName from "app/components/normal/FlexableFileName"
import MaterialModal from "app/components/normal/MaterialModal"
import DataOriginText from 'app/components/normal/DataOriginText'
import deleteAbleIcon from "app/styles/images/sp/delete.svg"
import { PREPARE_RUN, RUNNING, SUCCESS, FAIL } from 'app/utils/const'

const ObserverTable = observer(({ store, task, index, data }) => {
  const columns = [
    {
      title: "关系",
      dataIndex: "relationName",
      key: "history-relationName",
      width: "14.6%",
      render: (text, record, index) => {
        const obj = {
          children: text,
          props: {
            rowSpan: 1
          },
        }
        let endIndex

        // 相同样本名的数量
        const sameCount = task.datas.filter(item => {
          endIndex = index
          return item.relationName === text
        }).length

        // 这个样本名的起始index
        const startIndex = task.datas.findIndex(item =>
          item.relationName === text
        )

        /*
         * 如果相同样本名的数量大于1
         * 1. 第一个做单元格合并
         * 2. 其余设置rowSpan为0
         * 不大于1正常渲染即可
         */
        if (sameCount > 1 && index <= endIndex) {
          if (index === startIndex) {
            obj.props.rowSpan = sameCount
          } else {
            obj.props.rowSpan = 0
          }
        }

        return obj
      }
    },
    {
      title: "文件名称",
      dataIndex: "filename",
      key: "history-filename",
      width: "28.97%",
      render: (text) => {
        const { queryMap: { keywords } } = store.list

        return (
          <FlexableFileName filename={text} keywords={keywords} matched={true} />
        )
      }
    },
    {
      title: "基因",
      dataIndex: "genes",
      key: "history-sampleName",
      width: "19.84%",
      render: (text) => {
        const { list: { queryMap: { keywords } } } = store

        return (
          <MaterialTip
            title={text.toString()}
          >
            <div className="sample-name ellipsis">
              <Highlighter
                highlightClassName="lightlight"
                highlightStyle={{ fontWeight: "normal" }}
                searchWords={highlightable(text.toString(), keywords) ? [text.toString()] : []}
                textToHighlight={text.toString() || ""}
              />
            </div>
          </MaterialTip>
        )
      }
    }
  ]
  return (
    <Table
      className="children-table"
      columns={columns}
      rowKey={record => record.id + "datas"}
      dataSource={
        task.datas.slice()
      }
      pagination={false}
    />
  )
})

@inject("entrance", "auth") @observer
export default class ReportCard extends Component {
  constructor(props) {
    super(props)
    this.state = {
      shareModalShowed: false,
      remarksModalShowed: false,
      detailModal: false,
      dataSingle: {},
      dataIndex: 0,
      focusedSample: {},
      showDeleteModal: false,
      groupNameHistory: [],
      cancelShareModal: false,
    }
    this.clickedInfo = {
      id: "",
      count: 0
    }
  }

  showShareModal = () => {
    this.setState({
      shareModalShowed: true
    })
  }

  showRemarksModal = (record) => {
    this.setState({
      remarksModalShowed: true,
      dataSingle: record
    })
  }

  closeModal = (modal, cb) => {
    this.setState({
      [modal]: false
    })
    if (typeof cb === "function") {
      cb()
    }
  }

  shareGroup = (username, clearUsername) => {
    let { shareGroup, shareList } = this.props.store
    let groupId = this.props.data.groupId

    shareGroup(groupId, username)
      .then(res => {
        clearUsername()
        shareList.unshift(res)
        message.success("分享成功")
      }, err => {
        message.error(err.message)
      })
  }

  showModal = (field) => {
    this.setState({
      [field]: true
    })
  }

  closeModal = (modal, cb = () => { }) => {
    this.setState({
      [modal]: false
    }, cb)
  }

  renderGroupButtons = () => {
    let { data = {} } = this.props

    if (data.mine) {
      return (
        <Row type="flex" justify="center" align="middle" className="info-buttons clearfix">
          <a onClick={this.showShareModal}><Icon type="upload" />共享</a>
          <Link to={`/jab/main/array-pgt/data_manage/${data.groupId}`}>管理家系数据</Link>
        </Row>
      )
    } else {
      return (
        <Row type='flex' align='middle' justify='center' className='share-info'>
          <Icon type="share-alt" /> 数据来源于：<DataOriginText className='ellipsis'>{data.ownerName}</DataOriginText>
          <MaterialTip placement="bottom" title='取消分享'>
            <div
              className="cancel-share-btn cursor-p"
              onClick={() => this.showModal('cancelShareModal')}
            >
              <img src={cancelIcon} alt='' />
            </div>
          </MaterialTip>
        </Row>
      )
    }
  }

  toggleGroupNameHistory = (visible) => {
    if (visible) {
      //调接口
      const { store: { getHistory }, data: { groupId } } = this.props
      getHistory(groupId)
        .then(
          res => {
            this.setState({
              groupNameHistory: res
            })
          },
          err => {
            message.error("历史记录获取失败")
          }
        )
    } else {
      this.setState({
        groupNameHistory: []
      })
    }
  }

  renderGroupName = () => {
    const { data = {} } = this.props
    const { groupNameHistory } = this.state
    const { list: { queryMap: { keywords } } } = this.props.store
    const groupName = (
      <MaterialTip
        title={data.groupName}
      >
        <div className="cursor-p ellipsis">
          <Highlighter
            highlightClassName="lightlight"
            highlightStyle={{ fontWeight: "normal" }}
            searchWords={highlightable(data.groupName, keywords) ? [data.groupName] : []}
            textToHighlight={data.groupName}
          />
        </div>
      </MaterialTip>
    )

    if (data.hasHistory) {
      return (
        <WarningTip
          type="warningTip"
          text={groupName}
          justify="start"
          overlayClassName="ta-c"
          mainKeys={["versionNum", "name", "createTime"]}
          historyData={groupNameHistory}
          onVisibleChange={this.toggleGroupNameHistory}
        />
      )
    } else {
      return (
        <div>{groupName}</div>
      )
    }
  }

  expandedRowRender = (task) => {
    const { index, data, store } = this.props
    return (
      <ObserverTable
        store={store}
        task={task}
        data={data}
        index={index}
      />
    )
  }

  toggleExpand = (expanded, { familyId, id }) => {
    const { index, store } = this.props
    if (expanded) {
      store.getTaskDatas(familyId, id)
        .then(
          res => {
            store.setTaskDatas(index, id, res)
          },
          err => new Promise(function (resolve, reject) {
            message.error(err.message)
          })
        )
    }
  }

  previewReport = (reportId) => window.open(`/jab/array-pgt/${reportId}/preview`)

  checkOperatable = (record) => {
    return record.state !== RUNNING && record.state !== PREPARE_RUN
  }

  updateRemarks = (remark) => {
    const { store: { updateRemarks }, data } = this.props
    const { dataSingle } = this.state

    updateRemarks(data.groupId, dataSingle.id, remark)
      .then(
        res => {
          dataSingle.remark = remark
          this.setState({
            remarksModalShowed: false
          })
          message.success("修改报告备注成功")
        },
        err => {
          message.error(err.message)
        }
      )
  }

  clickThreeTime = (id, cb) => {
    this.clickedInfo = {
      id,
      count: this.clickedInfo.count + 1
    }

    if (this.clickedInfo.id !== id) {
      this.clickedInfo = {
        id,
        count: 1
      }
    }

    if (this.clickedInfo.count > 2) {
      cb()
      this.initClickInfo()
    }
  }

  initClickInfo = () => {
    this.clickedInfo = {
      id: "",
      count: 0
    }
  }

  handleShowDeleteModal = (record) => {
    this.setState({
      showDeleteModal: true,
      focusedSample: record,
    })
  }
  downloadCsvStep = (templateId) => {
    const { downloadCsvStep } = this.props.store
    this.setState({
      downLoadModal: true,
    })
    downloadCsvStep(templateId)
      .then(res => {
        this.setState({
          downLoadModal: false,
        })
        if (document.getElementById("download-a-tag")) document.getElementById("download-a-tag").outerHTML = ""
        let a = document.createElement("iframe")
        a.setAttribute("src", res.url)
        a.setAttribute("id", "download-a-tag")
        a.setAttribute("style", "display:none;")
        document.body.appendChild(a)
      }, err => {
        message.error("下载失败，请您重试！")
        this.setState({
          downLoadModal: false,
        })
      })
  }

  deleteReport = (reportId) => {
    const { focusedSample } = this.state
    const { store: { deleteReport }, data, data: { groupId } } = this.props
    deleteReport(groupId, reportId)
      .then(
        res => {
          const deleteIndex = data.reportList.indexOf(focusedSample)
          data.reportList.splice(deleteIndex, 1)
          this.setState({ showDeleteModal: false })
          message.success("报告删除成功")
        },
        err => {
          message.error(err.message)
        }
      )
  }

  render() {
    const { data = {}, store } = this.props
    let {
      shareModalShowed,
      remarksModalShowed,
      dataSingle,
      cancelShareModal,
      focusedSample
    } = this.state
    let reportList = data.reportList
    const columns = [
      {
        title: (<div className="ta-c">任务ID</div>),
        dataIndex: "id",
        width: "20.97%",
        render: (id) => {
          const { front, end } = ellipsisDispose(id)
          return (
            <MaterialTip
              title="点击三次复制完整任务ID"
              placement="bottom"
            >
              <Row
                className="ellipsis-wrapper cursor-p"
                type="flex"
                onClick={
                  () => this.clickThreeTime(
                    id,
                    () => copyText(id, "复制完整任务ID成功")
                  )
                }
              >
                <div className="ellipsis ellipsis-front">
                  {front}
                </div>
                <div className="ellipsis-end">{end}</div>
              </Row>
            </MaterialTip>
          )
        }
      },{
        title: (<div className="ta-c">芯片类型</div>),
        dataIndex: "chipType",
        width: "18.62%",
        render: (text) => <div className="ta-c">{text}</div>
      }, {
        title: (<div className="ta-c">运行应用</div>),
        dataIndex: "appName",
        width: "9.62%",
        render: (text) => <div className="ta-c">{text}</div>
      }, {
        title: (<div className="ta-c">应用版本</div>),
        dataIndex: "appVersion",
        width: "9.62%",
        render: (text) => <div className="ta-c">{text}</div>
      }, {
        title: (<div className="ta-c">开始运行时间</div>),
        dataIndex: "startTime",
        width: "15.75%",
        render: (text) => <div className="ta-c">{text}</div>
      }, {
        title: (<div className="ta-c">计算时间</div>),
        dataIndex: "computingTime",
        width: "10.62%",
        render: (text) => <div className="ta-c">{text}</div>
      }, {
        title: (<div className="ta-c">报告备注</div>),
        dataIndex: "remark",
        width: "12.62%",
        render: (text) => {
          return (
            <MaterialTip
              title={text}
            >
              <div className="ta-c ellipsis">{text}</div>
            </MaterialTip>
          )
        }
      }, {
        title: (<div className="ta-c">运行状态</div>),
        dataIndex: "state",
        width: "13.7%",
        render: (state, record) => {
          switch (state) {
            case PREPARE_RUN:
              return (
                <div className="ta-c">
                  <button className="pre-run">准备运行</button>
                </div>
              )
            case RUNNING:
              return (
                <div className="ta-c">
                  <button className="running">正在运行</button>
                </div>
              )
            case SUCCESS:
              return (
                <div className="ta-c">
                  <button className="report-view" onClick={() => this.previewReport(record.reportId)}>查看报告</button>
                </div>
              )
            case FAIL:
              return (
                <MaterialTip
                  title="请将任务ID发送至管理员">
                  <div className="ta-c">
                    <button className="run-fail">运行失败</button>
                  </div>
                </MaterialTip>
              )
            default:
              break
          }
        }
      },  {
        title: (<div className="ta-c">组数据</div>),
        dataIndex: "",
        width: "15.75%",
        render: (record) =>  
          <div className="ta-c">
            <a onClick={ () => this.downloadCsvStep( record.id )}>
              <Icon type="download" />下载
            </a>
          </div>
      },{
        title: (<div className="ta-c">Marker</div>),
        dataIndex: "marker",
        width: "10%",
        render: (text) => <div className="ta-c">{text}</div>
      }, {
        title: (<div className="ta-c">操作</div>),
        dataIndex: "oprator",
        width: 50,
        render: (text, record, index) => {
          //const operatable = this.checkOperatable(record)
          let imgClass = cx({
            "cursor-p": true,
            // "disable": !operatable
          })

          return (
            <Row className="table-oprator" type="flex" justify="space-between" align="middle">
              <img
                className={imgClass}
                alt="编辑"
                src={editAbleIcon}
                onClick={() => this.showRemarksModal(record)}
              />
              <img
                className={imgClass}
                title="删除"
                src={deleteAbleIcon}
                alt=""
                onClick={() => this.handleShowDeleteModal(record)}
              />
            </Row>
          )
        }
      }
    ]

    return (
      <Row type="flex" className="report-card">
        <div className="card-left">
          <div className="content">
            <div className="info">
              <Row type="flex" justify="start" className="info-group">
                <label>数据类型：</label>
                <p className="text-content">{data.appName}</p>
              </Row>
              <Row type="flex" justify="start" className="info-group">
                <label>所在家系：</label>
                <div className="text-content">
                  {this.renderGroupName()}
                </div>
              </Row>
              <Row type="flex" justify="start" className="info-group">
                <label>送检单位：</label>
                <div className="text-content">{data.organization}</div>
              </Row>
              <Row type="flex" justify="start" className="info-group">
                <label>文件数量：</label>
                <p className="text-content">{data.dataCount}</p>
              </Row>
              <Row type="flex" justify="start" className="info-group">
                <label>数据大小：</label>
                <p className="text-content">{disposeFileSize(data.totalSize)}</p>
              </Row>
              <Row type="flex" justify="start" className="info-group">
                <label>创建时间：</label>
                <p className="text-content">{data.createTime}</p>
              </Row>
            </div>
            {
              this.renderGroupButtons()
            }
          </div>
        </div>
        <MaterialModal
          title="报告删除确认"
          className="upload-delete-modal"
          buttonType="danger"
          buttonText="删除"
          visible={this.state.showDeleteModal}
          action={() => this.deleteReport(focusedSample.reportId)}>
          <img
            className="pgx-modal-close"
            src={closeIcon}
            alt="关闭对话框"
            onClick={() => this.closeModal("showDeleteModal")}
          />
          <div className="warning">
            <Icon type="exclamation-circle-o" />
            您确定要删除本条报告吗？
          </div>
        </MaterialModal>
        <Table
          columns={columns}
          className="task-table report-card-content"
          rowKey={record => record.id}
          onExpand={this.toggleExpand}
          expandedRowRender={this.expandedRowRender}
          dataSource={reportList.slice()}
          expandIconAsCell={false}
          pagination={false}
        />

        {/* 分享modal */}

        {shareModalShowed &&
          <ShareModal
            visible
            store={store}
            data={data}
            action={this.shareGroup}
            onCancel={this.closeModal}
          />
        }

        {/* 取消分享modal */}

        {cancelShareModal &&
          <MaterialModal
            className="pgs-datamanage-delete-modal"
            title="取消分享确认"
            visible={true}
            action={() => {
              store.cancelShare(data.groupId, data.ownerId, 'fromId')
                .then(
                  res => { this.closeModal("cancelShareModal") },
                )
            }}
            buttonText="确认"
            buttonType="danger"
          >
            <img
              className="pgx-modal-close"
              src={closeIcon}
              alt="关闭对话框"
              onClick={() => this.closeModal("cancelShareModal")}
            />
            <Row type="flex" justify="center" align="middle">
              {data.groupName}
            </Row>
            <Row className="warning-line1" type="flex" justify="center" align="middle" gutter={8}>
              <img src={deleteWarningIcon} alt="" />
              <div>您确认取消 {data.ownerName} 共享给您的数据吗？</div>
            </Row>
          </MaterialModal>
        }

        {/* 编辑modal */}

        {remarksModalShowed &&
          <RemarkModal
            visible
            action={this.updateRemarks}
            data={dataSingle}
            onCancel={this.closeModal}
          />
        }
      </Row>
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/components/normal/arrayPgt/ReportCard/index.js